export class UserFormSearchTO {
    query: string;
    formId: number;
}
